import { gsap } from 'gsap';
import type { RGB } from '../types/ambilight';

/**
 * Animación de entrada suave y cinematográfica al iniciar la app
 */
export function animateAppEntrance(
  container: HTMLElement | null,
  header: HTMLElement | null,
  bottomBar: HTMLElement | null
) {
  const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

  if (header) {
    tl.fromTo(header, { opacity: 0, y: -20 }, { opacity: 1, y: 0, duration: 0.6 });
  }

  if (container) {
    tl.fromTo(
      container,
      { opacity: 0, scale: 0.96 },
      { opacity: 1, scale: 1, duration: 0.8 },
      '-=0.35'
    );
  }

  if (bottomBar) {
    tl.fromTo(
      bottomBar,
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 0.6 },
      '-=0.3'
    );
  }

  return tl;
}

/**
 * Transición ultra suave de color entre frames para halos ambientales
 */
export function tweenGlowColor(
  target: HTMLElement,
  color: RGB,
  dimming = 100,
  duration = 0.2
) {
  const alpha = Math.max(0.15, dimming / 100);
  gsap.to(target, {
    '--node-r': color.r,
    '--node-g': color.g,
    '--node-b': color.b,
    '--node-alpha': alpha,
    duration,
    ease: 'power1.out',
    overwrite: 'auto',
  });
}

/**
 * Animación elástica para modales y menús flotantes
 */
export function animateModalOpen(element: HTMLElement) {
  gsap.fromTo(
    element,
    { opacity: 0, y: 15, scale: 0.95 },
    {
      opacity: 1,
      y: 0,
      scale: 1,
      duration: 0.3,
      ease: 'back.out(1.5)',
    }
  );
}
